import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAbility } from '../contexts/AbilityContext';
import type { AppSubject } from '../types/auth';
import type { AppAction } from '@/types/shared-enums.generated';
import { routeAccess } from './route-access';
import { LANDING_ORDER, gateForPath } from './routes';

/**
 * Redirecionador de entrada (`/`) e catch-all (`*`).
 *
 * Primeira rota de LANDING_ORDER que o usuário acessa (mesma regra do
 * ProtectedRoute): Painel Aduaneiro -> Dashboard -> PowerBI -> Perfil.
 * Dashboards (/paineis/launch) fica fora: ele sai do hub para o portal
 * externo de painéis, não é tela inicial.
 */
const RedirectToDefaultRoute: React.FC = () => {
  const { hasRank, hasCap, capabilities, isFeatureEnabled } = useAuth();
  const location = useLocation();
  const { ability } = useAbility();
  const ctx = {
    hasRank, hasCap, capabilities, isFeatureEnabled,
    can: (a: AppAction, s: AppSubject) => ability.can(a, s),
  };
  const target =
    LANDING_ORDER.find((p) => routeAccess(gateForPath(p)!, ctx) === 'ok') ?? '/perfil';
  // `key` por entrada de histórico (Wake): o <Navigate> só redireciona ao
  // montar. No login chegam dois `navigate('/')` (o do PublicRoute e o da tela
  // de login); se o segundo cai depois deste redirect e antes do React pintar o
  // destino, o React desenha `/` de novo sem desmontar este componente — e a
  // tela fica em branco, só com a sidebar. Com a key, cada chegada em `/`
  // redireciona.
  return <Navigate key={location.key} to={target} replace />;
};

export default RedirectToDefaultRoute;
